function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCurrentAccount, useCurrentProject, useCurrentProjectId } from '@adsk/alloy-provider';
import { useLocale } from '@adsk/alloy-react-locale';
import { PRODUCTS } from './consts';
import getAccountServices from './helpers/getAccountServices';
const useProducts = () => {
  const {
    T
  } = useLocale(_ref => {
    let {
      locale
    } = _ref;
    return require("./i18n/".concat(locale, ".json"));
  });
  const currentProject = useCurrentProject();
  const currentAccount = useCurrentAccount();
  const currentProjectId = useCurrentProjectId();
  const currentAccountServices = currentProjectId ? undefined : getAccountServices(currentAccount);
  if (currentProjectId) {
    const nonAdminProducts = (currentProject === null || currentProject === void 0 ? void 0 : currentProject.products.filter(product => product.category !== 'admin')) || [];
    const adminProducts = (currentProject === null || currentProject === void 0 ? void 0 : currentProject.products.filter(product => product.category === 'admin')) || [];
    return [...nonAdminProducts, ...adminProducts]; // admin products should be last
  }
  if (!currentAccountServices) return [];
  const products = PRODUCTS.filter(product => currentAccountServices.some(service => service.serviceType === product.serviceType));
  return products.map(product => {
    const currentService = currentAccountServices.find(service => service.serviceType === product.serviceType);
    const url = currentService.accountUrl;
    return _objectSpread(_objectSpread({}, product), {}, {
      name: T.translate(product.nameTranslationKey),
      key: product.id,
      defaultUrl: url,
      url
    });
  });
};
export { useProducts };
//# sourceMappingURL=useProducts.js.map